module.exports = __webpack_public_path__ + "img/5G.ba82345f.png";